import React from 'react';

function GenericPaginator(props) {

    const {
        rowsPerPageOptions,
        count,
        rowsPerPage,
        page,
        onPageChange,
        onRowsPerPageChange,
        showFirstButton,
        showLastButton
    } = props;

    const totalPages = Math.ceil(count / rowsPerPage);

    return (
        <nav aria-label="Page navigation">
            <ul className="pagination justify-content-center">
                <span>Page {page + 1} from {totalPages}</span>
                {
                    showFirstButton &&
                    <li className={`page-item prev ${page === 0 ? 'disabled' : ''}`} onClick={(evt) => { if (page > 0) onPageChange(evt, 0) }}>
                        <span className="page-link"><i className="tf-icon bx bx-chevrons-left"></i></span>
                    </li>
                }
                <li className={`page-item prev ${page === 0 ? 'disabled' : ''}`}>
                    <span className="page-link" onClick={(evt) => { if (page > 0) onPageChange(evt, page - 1) }}>
                        <i className="tf-icon bx bx-chevron-left"></i>
                    </span>
                </li>
                {
                    Array.apply(null, { length: totalPages }).map((e, i) => (
                        <li className={`page-item ${page === i ? 'active' : ''}`} >
                            <span className="page-link" onClick={(evt) => { onPageChange(evt, i) }}>{i + 1}</span>
                        </li>
                    ))
                }
                <li className={`page-item next ${page === totalPages - 1 ? 'disabled' : ''}`}>
                    <span className="page-link" onClick={(evt) => { if (page < totalPages - 1) onPageChange(evt, page + 1) }}><i className="tf-icon bx bx-chevron-right"></i></span>
                </li>
                {
                    showLastButton &&
                    <li className={`page-item next ${page === totalPages - 1 ? 'disabled' : ''}`}>
                        <span className="page-link" onClick={(evt) => { if (page < totalPages - 1) onPageChange(evt, totalPages - 1) }} ><i className="tf-icon bx bx-chevrons-right"></i></span>
                    </li>
                }

            </ul>
        </nav>
    );
}

export default GenericPaginator;